
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/tik-tok",
      function () {
        return require("private-next-pages/android/local/tik-tok/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/tik-tok"])
      });
    }
  